const formatInstance = (
	instance?: IFormInstance | null
): IFormInstance | undefined => {
	if (!instance) return;

	const { observationinstance_response: responses } = instance;

	responses.sort((question1, question2) => {
		if (
			question1.observationquestion.order < question2.observationquestion.order
		)
			return -1;
		if (
			question1.observationquestion.order > question2.observationquestion.order
		)
			return 1;
		return 0;
	});

	const response = responses.map(
		({
			observationquestion,
			id,
			created_at,
			completed_at,
			updated_at,
			uuid,
			value,
			compliant,
			overall_score,
			graded,
			great_conversation_grade_performance,
			great_conversation_grading_comments,
			action,
			images,
			great_conversation_correct
		}: IObservationInstanceResponse) => {
			const instanceResponse: InstanceResponse = {
				id: id,
				created_at: created_at,
				completed_at: completed_at,
				updated_at: updated_at,
				uuid: uuid,
				question: {
					id: observationquestion.id,
					uuid: observationquestion.uuid,
					questionNumber: observationquestion.order,
					questionType: observationquestion.question_type,
					question: observationquestion.question,
					note: observationquestion.note,
					order: observationquestion.order,
					givenAnswer: value,
					action: action,
					images,
					compliant,
					imageCoverId: observationquestion.image_cover_id,
					observationAnswers: observationquestion.observation_answers.map(
						(answer) => answer
					),
					isActionRequired: observationquestion.is_action_required,
					isCorrectAnswerRequired:
						observationquestion.is_correct_answer_required,
					isGreatConversationCorrect: great_conversation_correct,
					hasBranches: observationquestion.has_branches,
					branchType: observationquestion.branch_type,
					branches: observationquestion.branches
				},
				overall_score: overall_score,
				graded: graded,
				great_conversation_grade_performance:
					great_conversation_grade_performance,
				great_conversation_grading_comments: great_conversation_grading_comments
			};

			return instanceResponse;
		}
	);

	return {
		...instance,
		response
	};
};

export default formatInstance;
